<template>
  <ul class="list-group list-group-flush list my--3">
    <li v-for="(participant, index) in participants" :key="index" class="list-group-item px-0">
      <div class="row align-items-center">
        <div class="col">
          <h4 class="mb-0">
            <span v-if="participant.principal" class="text-primary">● </span>
            {{ participant.name }}
          </h4>
          <small>{{ participant.typeToShow }}</small>
        </div>

        <div class="col-auto">
          <div v-if="participant.principal">
            <badge type="primary">Principal</badge>
          </div>
          <div v-else>
            <base-button
              v-if="removeAction"
              outline
              size="sm"
              type="danger"
              title="danger"
              @click="removeParticipant(index)"
            >
              <i class="fa fa-trash"></i>&nbsp;Eliminar
            </base-button>
          </div>
        </div>
      </div>
    </li>

    <li v-if="participants.length === 0" class="list-group-item px-0">
      No existen participantes cargados en la visita.
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    participants: {
      type: Array,
      default: null,
    },

    removeAction: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    removeParticipant(index) {
      this.$emit('remove-participant', index);
    },
  },
};
</script>
